export default "__VITE_ASSET__5f480461__"